module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4gUKFQUqjCQjNQAAAMtJREFUSMdjYBgFo2AU0Bww45Jw9ihtVFKx3q+kYv3//p1jB3GoqVRSsT6spGL98v6dY2ewqWHCY/k3KN3o7FFah8XwZgYGhjYoV5RkH9y/c+yokor1ZwYGBncGBgZHJRVrpvt3jh2AGj6HgYGhAKq0fe+O7npc5jASCkNnj9I+BgaGQii3E0qXQ+m6vTu6m/HpZyQmopw9SicxMDDkogmX793R3UV2JKMF13YlFWsGBgYGB6hQH75gIRs4e5QmOHuU5o9mvlEwCkgDAGjkNwWbvqwHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow_down.png
// module id = 1412
// module chunks = 3 5